import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { closeDialog, selectApp } from '../../app/appSlice';

const ConfirmationDialog = () => {
  const dispatch = useAppDispatch();
  const { dialog } = useAppSelector(selectApp);

  const handleCancel = () => {
    dispatch(closeDialog());
  };

  const handleOk = () => {
    dialog.onOk && dialog.onOk();
    dispatch(closeDialog());
  };

  return (
    <Dialog open={dialog.open}>
      <DialogTitle>{dialog.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{dialog.description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button onClick={handleOk}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
